import React, { useEffect, useRef } from 'react';
import {
  StyledProfileOptions,
  StyledProfileHeader,
  StyledProfileListLinkItem,
  StyledProfileListText,
  StyledProfileListIcon,
  StyledProfileVersionListItem,
  StyledProfileWrapper,
  StyledProfileListTextItem,
} from './components/StyledProfileOptions';
import { StyledUserIconCircle, StyledUserIconInitial } from './components/StyledUserIconCircle';

const DropDownOptions = ({ listItems = [] }) => {
  if (listItems.length === 0) {
    return null;
  }

  return listItems.map((listItem) => {
    const { clickEvent, name, link, icon } = listItem;

    const ProfileListItem = clickEvent ? StyledProfileListTextItem : StyledProfileListLinkItem;

    return (
      <ProfileListItem title={name} onClick={clickEvent} to={!clickEvent ? link : '/'} key={name}>
        <StyledProfileListIcon>{icon}</StyledProfileListIcon>
        <StyledProfileListText>{name}</StyledProfileListText>
      </ProfileListItem>
    );
  });
};

export const UserProfileIcon = ({
  testId = 'user-circle',
  handleUserIconClick,
  isOpen = false,
  user,
  appVersion,
  dropdownOptions = [],
  onClose,
}) => {
  const dropdownRef = useRef(null);
  const initialLetter = (user?.name || user?.email || '').charAt(0).toUpperCase();
  const headerText = user?.name || user?.email;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose?.();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  return (
    <StyledUserIconCircle data-test-id={testId} ref={dropdownRef}>
      <StyledUserIconInitial onClick={handleUserIconClick}>{initialLetter}</StyledUserIconInitial>

      <StyledProfileWrapper $isActive={isOpen} onClick={handleUserIconClick} />

      <StyledProfileOptions $isActive={isOpen}>
        <StyledProfileHeader>{headerText}</StyledProfileHeader>

        <DropDownOptions listItems={dropdownOptions} />

        {appVersion && (
          <StyledProfileVersionListItem>
            <StyledProfileListText $dimmed>{appVersion}</StyledProfileListText>
          </StyledProfileVersionListItem>
        )}
      </StyledProfileOptions>
    </StyledUserIconCircle>
  );
};
